import { getAPIFromDomain } from "../lib/api";

export interface FeatureFlagResponse<Flag> {
  state: boolean;
  flag: Flag;
}
export const fetchFeatureFlag = async <Flag>(
  flag: Flag,
  tracking_options?: Record<string, unknown>
): Promise<FeatureFlagResponse<Flag>> => {
  const api = getAPIFromDomain("pigeon");
  const res = await api.get(`/api/feature-flags/${flag}`, {
    params: tracking_options,
  });
  return res.data;
};
